<template>
    <section class="table-scroller">
        <div class="taskHeader-container">
            <h3>
                Tasks
            </h3>

            <div>
                <ds-text-button
                    v-if="isShowCompleted"
                    class="task-btn"
                    data-qa="show-completed"
                    @click="showCompletedTasks"
                >
                    Show completed
                </ds-text-button>
                <ds-text-button
                    v-if="showCompleted"
                    class="task-btn"
                    data-qa="hide-completed"
                    @click="hideCompletedTasks"
                >
                    Hide completed
                </ds-text-button>
                <ds-filled-button
                    data-button-label="add-task"
                    data-qa="add-task-btn"
                    @click="showTaskModal"
                >
                    Add a task
                </ds-filled-button>
                <TaskForm ref="taskModal" :contact="contact" :user-id="userId" />
            </div>
        </div>

        <div v-if="isContactHasTasks" class="table-scroller" data-qa="task-table">
            <table class="task-table ">
                <tr v-for="(task, index) in tasks" :key="index" class="task-tr">
                    <td style="width: 5%">
                        <ds-checkbox
                            :value="task.completionDate != null"
                            data-qa="task-checkBox"
                            task
                            class="task-checkbox"
                            @input="handleTask($event, task)"
                        />
                    </td>

                    <td data-qa="task-deatils" style="width: 95%" @click="openTask(task.id)">
                        <div class="task-details" style="overflow-x:auto;">
                            <div class="task-info">
                                <span
                                    :style="[task.completionDate ? {'text-decoration':'line-through'} : {'text-decoration' : ''}]"
                                    class="task-name"
                                >{{ task.title }}</span>
                                <span class="user-name">Assigned to: {{ task.assignedUserName }}</span>
                            </div>

                            <div class="dueDate">
                                <span :style="[taskLate(task) ? {'color' : '#e02500'} : {'color' : 'black'}]">{{ task.dueDateAsString }}</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <div v-if="!isContactHasTasks" class="no-tasks-section">
            <p class="no-tasks-label">
                No tasks due. You’re all caught up!
            </p>
        </div>

        <div v-if="isTasksLimitOver" class="view-all-tasks">
            <span data-qa="tasks-count"> Showing {{ tasks.length }} of {{ tasksCount }}
                <ds-text-button class="show-all-tasks-button" @click="showAllTasks">
                    View all tasks
                </ds-text-button>
            </span>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import TaskForm from './TaskForm';

export default {
    components: {
        TaskForm,
    },

    props: {
        contact: Object,
        userId: [String, Number],
    },

    data() {
        return {
            tasks: [],
            pendingTasks: [],
            allTasks: [],
            contactId: this.contact.id,
            showCompleted: false,
            loaded: false,
            tasksCount: 0,
            MAX_TASKS_LIMIT: 25,
        };
    },

    created() {
        if (!this.loaded) {
            this.initTab();
            this.loaded = true;
        }
    },

    mounted() {
        this.$root.$on('TASK_STATUS', (isSuccess) => {
            if (isSuccess) {
                this.initTab();
            }
        });
    },

    beforeDestroy() {
        this.$root.$off('TASK_STATUS');
    },

    computed: {
        isContactHasTasks() {
            return this.tasks.length > 0;
        },

        isTasksLimitOver() {
            return this.tasksCount > this.MAX_TASKS_LIMIT && this.tasks.length >= this.MAX_TASKS_LIMIT;
        },

        isShowCompleted() {
            return !this.showCompleted && this.allTasks.length > this.pendingTasks.length;
        },
    },

    methods: {
        initTab() {
            this.loadContactTasks();
            this.getTasksCount();
        },

        async loadContactTasks() {
            try {
                const response = await axios.get(`/app/tasks/${this.contactId}`);

                this.pendingTasks = response.data.allPendingTasks;
                this.allTasks = response.data.allTasks;
                this.tasks = this.pendingTasks;

                if (this.showCompleted) {
                    this.tasks = this.allTasks;
                }
            } catch (e) {
                this.$error({ message: 'Unable to get all tasks' });
            }
        },

        async handleTask(event, task) {
            try {
                await axios.post(`/app/tasks/handleTask?taskId=${task.id}&taskComplete=${event}`);
            } catch (e) {
                this.$error({ message: 'unable to complete task' });
            }

            if (event) {
                task.completionDate = new Date();
            } else {
                task.completionDate = null;
            }
        },

        async getTasksCount() {
            try {
                const response = await axios.get(`/app/tasks/getTasksCount?contactId=${this.contactId}`);

                this.tasksCount = response.data;
            } catch (e) {
                this.$error({ message: 'unable to get Tasks count' });
            }
        },

        showCompletedTasks() {
            this.tasks = this.allTasks;
            this.showCompleted = true;
        },

        hideCompletedTasks() {
            this.tasks = this.pendingTasks;
            this.showCompleted = false;
        },

        showAllTasks() {
            window.open(`/app/myDay/home?tab=tasksTab&AssignedUser_DATA=${this.userId}&MainSearch_DATA=${this.contactId}&DateRange_DATA=all`);
        },

        taskLate(task) {
            const lateTask = (task.dateDiff < 0 || moment(task.dueDate).diff(moment()) < 0) && task.completionDate == null;

            if (lateTask) {
                return 'taskLate';
            }

            return null;
        },

        openTask(id) {
            this.taskId = id;
            this.$refs.taskModal.showModal(id);
        },

        showTaskModal() {
            this.$refs.taskModal.showModal(0);
        },
    },
};
</script>

<style lang="scss" scoped>
.task-info {
    display: flex;
    flex-direction: column;
    cursor: pointer;
}

.taskHeader-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: $spacing-200 0;
}

.task-btn {
    margin-right: $spacing-200;
}

.no-tasks-label {
    color: $color-gray-darker;
    font-size: $font-size-lg;
    font-weight: 300;
    padding-top: $spacing-800;
    padding-bottom: $spacing-600;
}

.no-tasks-section {
    width: 100%;
    text-align: center;
    border-top: 1px solid $color-gray-lighter;
    margin-top: $spacing-200;
}

.table-scroller {
    white-space: nowrap;
}

.view-all-tasks {
    text-align: center;
    margin-top: 1.75rem;
}

.show-all-tasks-button {
    padding: 0.4rem;
}

.task-table {
    border-collapse: collapse;
    border-top: 1px solid $color-gray-lighter;
    width: 100%;
    margin-top: $spacing-250;
}

.task-details {
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-top: auto;
    margin-bottom: auto;
    cursor: pointer;
}

.task-name {
    size: 1rem;
    line-height: $line-height-lg;
}

.dueDate {
    display: flex;
    align-items: center;
}

.task-tr:hover {
    background-color: $color-gray-20;
}

.user-name {
    height: 1.25rem;
    font-size: $font-size-xs;
}

.task-table > tr:last-child {
    border-bottom: 0;
}
</style>
